<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant
            type="search"
            name="plantCd"
            v-model="searchParam.plantCd"
            @input="getList"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="LBLPERIOD"
            name="period"
            v-model="period"
            @input="getList"
          />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="TBM 목록"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :selection="popupParam.type"
          rowKey="tbmId"
          @linkClick="linkClick"
          @rowDblclick="rowDblclick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline>
              <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
              <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "tbm-pop",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          type: "single",
          plantCd: "",
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            style: "width:140px",
            align: "center",
            sortable: true,
          },
          {
            name: "tbmNo",
            field: "tbmNo",
            label: "TBM번호",
            style: "width:100px",
            align: "center",
            sortable: true,
          },
          {
            name: "tbmName",
            field: "tbmName",
            label: "TBM명",
            align: "left",
            style: "width:200px",
            type: "link",
            sortable: true,
          },
          {
            name: "permitNo",
            field: "permitNo",
            label: "작업허가번호",
            style: "width:100px",
            align: "center",
            type: "link",
            sortable: true,
          },
          {
            name: "tbmWorkDate",
            field: "tbmWorkDate",
            label: "작업일",
            style: "width:80px",
            align: "center",
            sortable: true,
          },
          {
            name: "tbmCompleteFlagName",
            field: "tbmCompleteFlagName",
            label: "작성상태",
            style: "width:80px",
            align: "center",
            sortable: true,
          },
          {
            name: "processName",
            field: "processName",
            style: "width:80px",
            label: "LBLPROCESS",
            align: "center",
            sortable: true,
          },
          {
            name: "vendorName",
            field: "vendorName",
            style: "width:80px",
            label: "업체",
            align: "center",
            sortable: true,
          },
          {
            name: "sopName",
            field: "sopName",
            style: "width:120px",
            label: "LBLJOB",
            align: "center",
            sortable: true,
          },
          {
            name: "tbmWorkResponsibleName",
            field: "tbmWorkResponsibleName",
            label: "작업책임자",
            style: "width:80px",
            align: "center",
            sortable: true,
          },
          {
            name: "workUserCount",
            field: "workUserCount",
            label: "외",
            style: "width:40px",
            align: "center",
            sortable: true,
          },
          {
            name: "permitTypeName",
            field: "permitTypeName",
            label: "허가서구분",
            style: "width:80px",
            align: "center",
            sortable: true,
          },
          {
            name: "workTime",
            field: "workTime",
            label: "작업시간",
            style: "width:80px",
            align: "center",
            sortable: true,
          },
        ],
        data: [],
        height: "500px",
      },
      period: ["", ""],
      searchParam: {
        startYmd: "",
        endYmd: "",
        plantCd: "",
        processCd: "",
      },
      editable: true,
      listUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        // isFull: true,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sai.tbm.list.url;
      this.getList();
    },
    getList() {
      this.searchParam.startYmd = this.period[0];
      this.searchParam.endYmd = this.period[1];

      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./tbmDetail.vue"}`);
      this.popupOptions.title = "TBM 상세";
      this.popupOptions.param = {
        tbmId: result ? result.tbmId : "",
      };
      this.popupOptions.isFull = true;
      // this.popupOptions.width = '95%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "TBM을 지정하세요.", // TBM을 지정하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
  },
};
</script>
